import {GridToolbarContainer, GridToolbarQuickFilter} from '@mui/x-data-grid';
import * as React from 'react';
import {useEffect, useState} from 'react';

interface CustomFilterToolBarProps {
  placeholderText?: string;
  onFilterChange: (value: string) => void;
  debounceMs?: number;
}

/**
 * A custom MUI DataGrid toolbar that provides a debounced search filter.
 * It manages the input state internally and only notifies the parent component
 * with the final search term after the user has stopped typing.
 *
 * @param {object} props - The component props for the CustomFilterToolBar
 * @param {string} [props.placeholderText] - Optional. Custom placeholder text for the search input.
 * @param {function(string): void} props.onFilterChange - Callback that fires after the debounce timer. It receives the final search term as a string.
 * @param {number} [props.debounceMs=250] - The delay in milliseconds before the onFilterChange callback is fired.
 * @constructor
 */
export const CustomFilterToolBar = ({placeholderText, onFilterChange, debounceMs = 250}: CustomFilterToolBarProps) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      onFilterChange(inputValue);
    }, debounceMs);

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, debounceMs, onFilterChange]);

  return (
    <GridToolbarContainer>
      <GridToolbarQuickFilter
        placeholder={placeholderText}
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        autoComplete={'off'}
      />
    </GridToolbarContainer>
  );
};
